import React, { Component } from "react";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { SET_VALID } from "../constants";
import "../style/video.scss";
import { currentLocale } from "../locale"
class ResponsivePlayer extends Component {
  componentDidMount() {
    this.props.dispatch({ type: SET_VALID, payload: true });
  }

  render() {
    const { waiver } = this.props;

    return (
      <React.Fragment>
        <nav className="level">
          <div className="level-item ">
            <h1 className="subtitle">{currentLocale.clickToPlay}</h1>
          </div>
        </nav>
        <div id="Media-Player" className="player-wrapper">
          <ReactPlayer
            controls
            className="react-player"
            ref={this.ref}
            url={waiver.videoUrl}
            playing={this.props.playing}
            onDuration={this.onDuration}
            step={this.props.steps}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({});
const mapActionToProps = dispatch => ({
  dispatch
});
const connector = connect(
  mapStateToProps,
  mapActionToProps
);
export default connector(ResponsivePlayer);
